import React from "react";
import SubMenu from "../../base/SubMenu";
import Start from "./Start";
import OrganisationsformA from "./OrganisationsformA";
import OrganisationsformB from "./OrganisationsformB";
import Downloads from "../base/Downloads";


function Fachoberschule(props) {
    const startRef = React.createRef()
    const orgARef = React.createRef()
    const orgBRef = React.createRef()
    const downloadsRef= React.createRef()

    return (
        <React.Fragment>
            <SubMenu model={{
                background: "#D6EDFE",
                items: [
                    { label: <strong>Fachoberschule</strong>},
                    { label: "Start", onClick: () => window.location.href = "/bildungsangebote/fachoberschule"},
                    {label: "FOS", onClick:()=>startRef.current.scrollIntoView() },
                    { label: "Organisationsform A", onClick: () => orgARef.current.scrollIntoView()},
                    { label: "Organisationsform B", onClick: () => orgBRef.current.scrollIntoView()},
                    { label: "Downloads", onClick: () => downloadsRef.current.scrollIntoView()}
                ]
            }}/>
            <div ref={startRef}><Start/></div>

            <div ref={orgARef} ><OrganisationsformA/></div>
            <div ref={orgBRef} ><OrganisationsformB/></div>
            <div ref={downloadsRef} className="wrapper wrapperContent" style={{color:"#488e62" }}>
            <Downloads
                model={
                    {
                        items: [
                            {label: 'FOS Anmeldeformular', download: 'FOS Anmeldeformular.pdf', url: '/assets/fachoberschule/Schulvertrag_FOS_mai25.pdf'},
                            {label: 'FOS Praktikantenvertrag', download: 'FOS Praktikantenvertrag Wirtschaft .pdf', url: '/assets/fachoberschule/FOS Praktikantenvertrag Wirtschaft .pdf'},
                            {label: 'FOS Vordruck Entschuldigungsschreiben',download: 'FOS Vordruck Entschuldigungsschreiben.pdf',url: '/assets/fachoberschule/FOS Vordruck Entschuldigungsschreiben.pdf'},
                            {label: 'FOS Lehrplan Wirtschaft und Verwaltung',download: 'FOS Lehrplan.pdf',url: '/assets/fachoberschule/FOS Lehrplan.pdf'}
                        ]
                    }
                }/>
            </div>
        </React.Fragment>

    );
}

export default Fachoberschule;
